const DEFINE = {
  STR: 'STR',
  NUMBER: 'DOUBLE',
  DATE: 'DATE',
  SINGLE: 'SINGLE',
  ARRAY: 'ARRAY',
  ID: 'ID',
  SEQUENCE: 'Sequence',
  TABULAR: 'Tabular',
  TREE: 'Tree'
} as const;
const TYPE = {
  BAR: 'bar',
  LINE: 'line'
};
export default DEFINE;
